import { Icon, IconProps } from '@chakra-ui/react'

export const BitcoinIcon = ({ ...props }: IconProps) => {
  return (
    <Icon viewBox="0 0 25 31" {...props}>
      <path
        d="M1.5 4.25116L13.0834 4.25119C13.4198 4.25119 13.588 4.25119 13.889 4.2816C14.0662 4.29951 14.5097 4.37469 14.6829 4.41617C14.9771 4.48661 15.0454 4.51047 15.1821 4.55818C16.801 5.12316 19.7846 6.5242 19.9697 9.21841C20.2128 12.7588 15.5625 14.1856 15.5625 14.1856M15.5625 14.1856H4.3125M15.5625 14.1856C15.5625 14.1856 24 14.8952 24 20.5721C24 25.5393 17.6719 26.2489 17.6719 26.2489L1.5 26.2489M4.3125 4.25119V26.2489M10.6406 4.2511V1M6.42188 29.5V26.2489M6.42188 4.25113V1.00002M10.6406 29.5V26.2489"
        stroke="currentColor"
        strokeOpacity="0.64"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </Icon>
  )
}
